<template>
  <CouponGuide
    class="cross-coupon-guide"
    v-if="!isNewUser"
    :dpPageId="DP_PAGE"
    :dpPositionId="MAINLAND_COUPON_GUIDE_POSID"
    entry="北上精选"
    :isShowHeader="false"
  ></CouponGuide>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { to } from '@tencent/wphk-base-utils';
import { CouponGuide } from '@tencent/wphk-components-coupon-guide';
import { isReturningHKUser } from '@/api';
import { MAINLAND_COUPON_GUIDE_POSID } from '@/config/module-config/mainland';
import { DP_PAGE } from '@/config/dp';

const isNewUser = ref(false);
onMounted(async () => {
  const [err, result] = await to(isReturningHKUser());
  if (err || !result) return;
  isNewUser.value = true;
});
</script>

<style lang="less" scoped>
@import (reference) "~@/less/main.less";
</style>
